import { get } from "lodash";

import { parseBoolean } from "@ryde/shared";

/**
 * RYDE-8171: a shift grid row is meal-only when its `metadata.isMealOnly` custom field is on.
 * The grid only carries the field for companies whose grid schema includes it; string values
 * ("true") are accepted because metadata custom fields are not always stored as booleans.
 */
export const isMealOnlyShiftRow = (rowOriginal: unknown): boolean =>
  parseBoolean(get(rowOriginal, "metadata.isMealOnly"));
